import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, ShoppingCart, User, Wallet } from "lucide-react";
import { ROUTES } from "@/constants/routes";
import { cn } from "@/lib/utils";

const ITEMS = [
    { label: "Home", to: ROUTES.home, icon: Home },
    { label: "Categories", to: ROUTES.categories, icon: LayoutGrid },
    { label: "Wallet", to: "/wallet", icon: Wallet },
    { label: "Cart", to: ROUTES.cart, icon: ShoppingCart },
    { label: "Profile", to: ROUTES.profile, icon: User },
] as const;

/**
 * Mobile-only bottom tab bar.
 * - Visible below `md` breakpoint.
 * - Respects iOS safe-area with `env(safe-area-inset-bottom)`.
 */
export function BottomNav() {
    return (
        <nav
            data-testid="bottom-nav"
            aria-label="Primary"
            className="fixed inset-x-0 bottom-0 z-40 border-t border-border/70 bg-background/95 backdrop-blur md:hidden"
            style={{ paddingBottom: "var(--safe-bottom)" }}
        >
            <ul className="tsgo-container grid grid-cols-5 gap-1 px-2 py-1.5">
                {ITEMS.map(({ label, to, icon: Icon }) => (
                    <li key={to}>
                        <NavLink
                            to={to}
                            data-testid={`bottom-nav-${label.toLowerCase()}`}
                            className={({ isActive }) =>
                                cn(
                                    "flex flex-col items-center justify-center gap-0.5 rounded-lg px-1 py-1.5 text-[11px] font-medium transition",
                                    isActive
                                        ? "text-brand"
                                        : "text-muted-foreground hover:text-foreground",
                                )
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    <Icon
                                        className={cn(
                                            "h-5 w-5 transition",
                                            isActive && "scale-110",
                                        )}
                                        strokeWidth={isActive ? 2.4 : 1.8}
                                    />
                                    <span>{label}</span>
                                </>
                            )}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}

export default BottomNav;
